import IFrameContainer from "app/components/IFrameContainer/IFrameContainer";
import { WidgetHelper } from "app/helpers/widgetHelper";
import { geniusGametrackerSports } from "app/utils/const";
import { useCallback, useEffect, useRef, useState } from "react";
import "./GeniusWidget.scss";

type Props = {
  sportType: string;
  darkMode: boolean;
  sourceFixtureId: string;
  standAloneSection?: string;
};

const GeniusWidget = (props: Props) => {
  const [iFrameUrl, setIframeUrl] = useState("");
  const prevDarkMode = useRef(props.darkMode);

  const getIframeUrl = useCallback(() => {
    const newIframeUrl = WidgetHelper.getGeniusIFrameURL(
      props.sportType,
      props.sourceFixtureId,
      props.standAloneSection
    );
    setIframeUrl(newIframeUrl);
  }, [props.sourceFixtureId, props.sportType, props.standAloneSection]);

  useEffect(() => {
    getIframeUrl();
  }, [getIframeUrl]);

  useEffect(() => {
    if (props.darkMode !== prevDarkMode.current) {
      getIframeUrl();
    }

    prevDarkMode.current = props.darkMode;
  }, [getIframeUrl, props.darkMode]);
  const size =
    !props.standAloneSection &&
    geniusGametrackerSports.includes(props.sportType);

  return (
    <div
      className={`genius-widget ${
        size ? "genius-widget-large" : "genius-widget-small"
      }`}
    >
      {iFrameUrl && <IFrameContainer src={iFrameUrl} title="" />}
    </div>
  );
};

export default GeniusWidget;
